var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.5 6L0.25 0.75H10.75L5.5 6ZM5.5 12L0.25 6.75H10.75L5.5 12Z","fill":"currentColor"}));
}

SVGIcon.defaultProps = {"width":"11","height":"12","viewBox":"0 0 11 12","fill":"none"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
